// extracted by mini-css-extract-plugin
export default {"wrap":"index-module--wrap--CCB3o","bodyLeft":"index-module--body-left--JjZq-","bodyRight":"index-module--body-right--9io7r"};